var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTailwindicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 41,
    viewBox: "0 0 69 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6562 13.9656C19.9021 4.98227 25.5167 0.490601 34.5 0.490601C47.975 0.490601 49.6594 10.5968 56.3969 12.2812C60.8885 13.4041 64.8187 11.7198 68.1875 7.2281C65.9417 16.2114 60.3271 20.7031 51.3438 20.7031C37.8688 20.7031 36.1844 10.5969 29.4469 8.91248C24.9552 7.78956 21.025 9.47393 17.6562 13.9656ZM0.8125 34.1781C3.05833 25.1948 8.67292 20.7031 17.6562 20.7031C31.1313 20.7031 32.8156 30.8093 39.5531 32.4937C44.0448 33.6166 47.975 31.9323 51.3438 27.4406C49.0979 36.4239 43.4833 40.9156 34.5 40.9156C21.025 40.9156 19.3406 30.8093 12.6031 29.125C8.11146 28.0021 4.18125 29.6864 0.8125 34.1781Z",
    fill: "#44A8B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailwindicon);
export default __webpack_public_path__ + "static/media/tailwindicon.dd7e4060fa3a5e5c2e5d4fb08211a3d2.svg";
export { ForwardRef as ReactComponent };